module.exports = __webpack_public_path__ + "static/media/icon_01.ab7eb01c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_01.png
// module id = 1642
// module chunks = 1